/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-16 13:55:15
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-10-21 12:03:33
 */
import http from '@/axios/index'

/**
 * @brief: 根据标签码获取机构配置参数状态
 * @author: Scarlett Xiao
 * @Date: 2022-03-16 13:55:53
 * @param {*} userCode 用户帐号
 */
/**
 * @brief: 根据标签码获取机构配置参数状态
 * @author: Scarlett Xiao
 * @Date: 2022-10-21 12:02:42
 * @param {string} orgId 机构id
 * @param {Array<string>} statusTypeArr 机构配置参数类型
 */
export function listParamStatus(orgId, statusTypeArr) {
  const params = {
    'orgId': orgId,
    'typeList': statusTypeArr
  };
  const url = '/orgParam/listParamStatus';
  return http.post(url, params);
}